export class Student {
    id?: number;
    firstName: string;
    lastName: string;
    dateOfBirth?: string | null;
    gender?: string | null;
}
